import convertContactToUpsert from '@afosto/utils/convertContactToUpsert';
import { contacts as contactsApi } from '@afosto/contacts/api/Contacts';

export default async (contact, organisation, addAsPrimary = false) => {
  try {
    const upsertedContact = convertContactToUpsert(contact);
    const contactOrganisations = upsertedContact?.organisations ?? {};

    if (addAsPrimary || !contactOrganisations.primary) {
      upsertedContact.organisations.secondary = [
        ...contactOrganisations.secondary,
        ...(contactOrganisations?.primary ? [contactOrganisations.primary] : []),
      ];

      upsertedContact.organisations.primary = {
        id: organisation.id,
        version: organisation.version,
      };
    } else {
      upsertedContact.organisations.secondary = [
        ...contactOrganisations.secondary,
        { id: organisation.id, version: organisation.version },
      ];
    }

    const updatedContactResponse = await contactsApi.upsertContact(upsertedContact);
    const { data: updatedContact } = updatedContactResponse;

    return updatedContact;
  } catch (err) {
    return Promise.reject(err);
  }
};
